module.exports = __webpack_public_path__ + "static/media/warning_icon.a563bf7f.svg";